import React from 'react';
import cx from 'classnames';
import { get } from 'lodash';
import SimpleImage from 'components/Common/Image/SimpleImage';
import getImageUrl from 'utils/getImageUrl';
import { SnippetType } from 'typings/SnippetType';
import RichTextView from 'components/FormattedMessage/RichTextView';
import styles from './FormattedMessage.css';
export default function FormattedMessage(props) {
    const { data, messageStyle } = props;
    if (!data) {
        return null;
    }
    const { title, containerClass, titleClass, contentClass, textClass, imageSize, imageClass } = props;
    const titleText = get(title, ['data', '0', 'value', 'text']);
    const contentStyle = messageStyle && getMessageStyle(messageStyle);
    return (<div className={containerClass}>
			{titleText && <div className={titleClass}>{titleText}</div>}

			<div className={contentClass} style={contentStyle}>
				{data.map(({ value }, index) => {
        if (!value) {
            return null;
        }
        switch (value.type) {
            case SnippetType.ImageValue:
                return (<SimpleImage key={index} src={getImageUrl(get(value, ['dynamicImageUrl']), '100')} containerClass={cx(styles['image-snippet'], imageClass)} size={imageSize}/>);
            case SnippetType.RichTextValue: {
                return <RichTextView key={index} value={value} textClass={textClass}/>;
            }
            default:
                return null;
        }
    })}
			</div>
		</div>);
}
function getMessageStyle(messageStyle) {
    const { borderRadius, backgroundColor, padding } = messageStyle;
    const style = {};
    if (padding) {
        if (padding.top !== undefined || padding.top !== null) {
            style.paddingTop = padding.top;
        }
        if (padding.right !== undefined || padding.right !== null) {
            style.paddingRight = padding.right;
        }
        if (padding.bottom !== undefined || padding.bottom !== null) {
            style.paddingBottom = padding.bottom;
        }
        if (padding.left !== undefined || padding.left !== null) {
            style.paddingLeft = padding.left;
        }
    }
    if (borderRadius) {
        style.borderRadius = `${borderRadius}px`;
    }
    if (backgroundColor) {
        style.backgroundColor = backgroundColor;
    }
    return style;
}
